import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { keyframes } from '@emotion/react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { DEFAULT_REVEAL_PROPS } from '../../../../reveal.constants';
import { BaseRevealOptionsPropTypes } from '../../../../types/reveal.types';
import Reveal from '../../Reveal';
import './FadeReveal.less';
var defaultProps = _objectSpread(_objectSpread({}, DEFAULT_REVEAL_PROPS), {}, {
  className: '',
  children: null,
  content: null
});
export default function FadeReveal(_ref) {
  var className = _ref.className,
    children = _ref.children,
    content = _ref.content,
    duration = _ref.duration,
    delay = _ref.delay,
    disableAnimation = _ref.disableAnimation,
    disableAnimationOnMobile = _ref.disableAnimationOnMobile,
    cascade = _ref.cascade,
    cascadeFactor = _ref.cascadeFactor,
    triggerOnce = _ref.triggerOnce,
    onVisibilityChange = _ref.onVisibilityChange,
    fraction = _ref.fraction,
    noContainer = _ref.noContainer;
  var finalClassName = classNames(_defineProperty({
    fade: true
  }, className, className));
  var opacityFrames = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n"])));
  return /*#__PURE__*/React.createElement(Reveal, {
    content: content,
    className: finalClassName,
    duration: duration,
    delay: delay,
    disableAnimation: disableAnimation,
    disableAnimationOnMobile: disableAnimationOnMobile,
    cascade: cascade,
    cascadeFactor: cascadeFactor,
    triggerOnce: triggerOnce,
    onVisibilityChange: onVisibilityChange,
    keyFrames: opacityFrames,
    fraction: fraction,
    noContainer: noContainer
  }, children);
}
FadeReveal.defaultProps = defaultProps;